import {
    Typography,
    Breadcrumbs as MuiBreadcrumbs,
} from '@mui/material'

import { Fragment } from 'react'

import { createId } from '../../services/utils'

import Link from '../Link'

export const Breadcrumbs = (props) => {
    return (
        <Typography
            variant={(props.variant) ? props.variant : 'h1'}
            sx={(props.sx) ? props.sx :  {mb: 1}}
        >
            <MuiBreadcrumbs {...props.muiBase}>
                {props.routes && props.routes.map(item => {
                    if (item.link && item.label)
                        return (<Link key={createId()} href={item.link} noIcon variant={item.variant || 'primary'}>{item.label}</Link>)
                    else if (!item.link && item.label)
                        return (<Typography key={createId()} variant={'body2'}>{item.label}</Typography>)
                    else return (<Fragment key={createId()}></Fragment>)
                })}
            </MuiBreadcrumbs>
        </Typography>
    )
}

export default Breadcrumbs